<template>
	<div class="data-wrap">
		<!-- 登录pc -->
		<div class="content-wrap hidden-sm-and-down" style="padding-bottom: 40px;">
			<div class="no-login-wrap">
				<div class="sys-desc">
					<div class="u-font-16 fw u-text-center u-m-b-10">千村调查简介</div>
					<div v-html="sys_info" class="edit-back info"></div>
				</div>
				<div class="login-right" v-if="!$store.state.username">
					<div class="no-login u-font-14">登录后查看数据</div>
					<div class="login-type">
						<div class="u-flex u-row-center" @click="go_login(2)">
							<img src="../assets/in-school.png">
							<span>校内用户登录</span>
						</div>
						<div class="u-flex u-row-center" @click="go_login(1)">
							<img src="../assets/out-school.png">
							<span>校外用户登录</span>
						</div>
					</div>
				</div>
				<div class="login-right" v-if="$store.state.username">
					<div class="login-type">
						<div class="u-flex u-row-center" @click="go_login(3)">
							<img src="../assets/apply.png">
							<span>查看数据</span>
						</div>
					</div>

				</div>
			</div>

		</div>

	<div class="content-wrap hidden-md-and-up mobile-wrap">
			<div class="login-type u-row-center u-flex" v-if="$store.state.username">
				<div class="u-flex u-row-center" @click="go_login(3)">
					<img src="../assets/apply.png">
					<span>查看数据</span>
				</div>
			</div>
			<div v-if="show_login" class="u-flex u-row-center u-decoration-col">
				<div class="u-font-16 u-m-t-18">登录后查看数据</div>
				<div class="login-type">
					<div class="u-flex u-row-center" @click="go_login(2)">
						<img src="../assets/in-school.png">
						<span>校内用户登录</span>
					</div>
					<div class="u-flex u-row-center" @click="go_login(1)">
						<img src="../assets/out-school.png">
						<span>校外用户登录</span>
					</div>
				</div>
			</div>
			<div class="sys-desc-mobile">
				<div class="u-font-16 fw u-text-center u-m-b-10">千村调查简介</div>
				<div v-html="sys_info" class="edit-back info"></div>
			</div>
			
			
		
	
	</div>
	</div>
</template>

<script>
	import {
	  getToken,
	  removeToken,
	  setToken,
	  removeCookie,
	  getCookie
	} from "@/utils/auth";
	export default {
		name: 'Data',
		components: {},
		data() {

			return {
				sys_info: '', //千村调查简介


				show_login: false,

			}
		},

		activated() {
			// console.log(6666);
			if (this.$store.state.username || getToken() || this.getCookie("csrftoken")) {
				this.show_login = false




			} else {
				this.show_login = true

			}

		},
		async mounted() {
			// 获取系统信息接口
			const sys_info = await this.$API.system_introduce()
			this.sys_info = sys_info.data.results.length ? sys_info.data.results[0].content : ''
		},
		methods: {
			getCookie(name) {
				var r = document.cookie.match("\\b" + name + "=([^;]*)\\b");
				return r ? r[1] : undefined;
			},
			go_login(type) {
				if (type == 1) {
					this.$router.push('/login')
				} else if (type == 2) {
					location.href = window.location.origin + "/login-in-school/"
				} else {
					this.$router.push('/apply')
				}
			}
		},
	}
</script>

<style lang="less" scoped>
	.mobile-wrap{
		.login-type {
		
			// margin: 44PX 0 24PX;
			div:last-child {
				background-color: #f6ad3c;
				margin-bottom: 30px;
			}
		
			div:first-child {
				background-color: #7c2326;
				margin: 10px 0;
		
			}
		
		
		
			div {
				padding: 0;
				cursor: pointer;
				border-radius: 4px;
				box-sizing: border-box;
				width: 180px;
				height: 46px;
		
				img {
					width: 28px;
					height: 28px;
					margin-right: 14px;
				}
		
				span {
					color: #ffffff;
					font-size: 16PX;
				}
			}
		}
	}
	.my-dialog {
		height: 74vh;
		overflow: auto;
	}

	.no-login-wrap {
		// font-size: 14PX;
		color: #333333;
		// font-weight: 700;
		margin-left: 200px;
		display: flex;

		.sys-desc {
			width: 600px;
			margin-right: 20px;
			margin-top: 50px;
		}

		.login-right {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			margin-top: 14px;
		}

		.login-type {

			// margin: 44PX 0 24PX;
			div:last-child {
				background-color: #f6ad3c;
			}

			div:first-child {
				background-color: #7c2326;
				margin: 20px 0;

			}



			div {
				padding: 0;
				cursor: pointer;
				border-radius: 4px;
				box-sizing: border-box;
				width: 180px;
				height: 46px;

				img {
					width: 28px;
					height: 28px;
					margin-right: 14px;
				}

				span {
					color: #ffffff;
					font-size: 16PX;
				}
			}
		}
	}

	.content-wrap {
		width: 100%;
		margin: 0 auto;
		max-width: 1000PX;
		// padding: 0 12PX;
		box-sizing: border-box;

		.search-wrap {
			span {
				// width: 72PX;
				font-size: 14PX;
			}

			/deep/ .el-select__tags-text {
				font-size: 12PX;
			}
		}

		.el-button {
			width: 80px;
			min-width: 50PX;
			color: #fff;
			// font-size: 8PX !important;
		}

		.bg1 {
			background-color: #b81c22;
			width: 100px;
			min-width: 70PX;
		}

		.bg2 {
			background-color: #f6ad3c;
			width: 100px;
			min-width: 70PX;
		}

		.pointer {
			cursor: pointer;
		}
	}

	/deep/ .el-dialog__header {
		padding: 0 !important;
	}

	/deep/ .el-dialog {
		width: 90% !important;
		max-width: 540PX !important;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}


	.el-form-item {
		margin-bottom: 16px;

		/deep/ .el-form-item__label {
			color: #333333 !important;
		}

		.el-select,
		.el-cascader {
			width: 100%;
		}

	}

	.dialog-footer {
		display: flex;
		justify-content: center;

		.cancle {
			border: 1px solid #7c2326;
			color: #7c2326;
			font-weight: 700;
			width: 86px;
			min-width: 72PX;
			margin-right: 140px;
			background-color: #fff;
		}

		.sure {
			background-color: #7c2326;
			color: #fff;
			width: 86px;
			min-width: 72PX;
		}
	}

	.tongyi {
		font-size: 14PX;
		color: #7c2326;
		font-weight: 700;
	}

	.agree-btn {
		width: 354px;
		min-width: 160PX;
		background-color: #7c2326;
		color: #fff;
	}

	.agree-btn:hover {
		background-color: #7c2326;
		color: #fff;
	}

	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #7c2326;
		color: #FFF;
	}

	/deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #fff;
	}

	/deep/ .el-pagination.is-background .el-pager li {

		background-color: rgba(124, 35, 38, .1);
	}
</style>
<style scoped>
	/* >>>不能用less会报错 */
	.info>>>img{
		max-width: 100% !important;
		width: 100%;
		/* margin: 20px; */
	}
	.info{
		overflow: hidden;
		color: #333;
		/* line-height: 26px;
		font-size: 14px; */
	}
</style>
